import clsx from 'clsx';
import * as React from 'react';
import css from './badge.module.scss';
import { Badge as BaseBadge } from '@mui/base/Badge';

type Props = {
  variant?: 'default' | 'inline' | 'standalone';
  max?: number;
  color?: 'default' | 'primary' | 'success' | 'error' | 'black';
  size?: 'default' | 'small' | 'large';
  dimmed?: boolean;
};

function Badge({
  children,
  badgeContent,
  expand,
  variant = 'default',
  color = 'default',
  size = 'default',
  dimmed,
  max,
  ...rest
}: React.ComponentProps<typeof BaseBadge> & Props) {
  return (
    <BaseBadge
      {...rest}
      slotProps={{
        root: {
          className: clsx(
            css.root,
            expand && css['is-expanded'],
            variant && css[`variant-${variant}`],
            color && css[`color-${color}`],
            size && css[`size-${size}`],
          ),
        },
        badge: {
          className: css.badge,
          ...(dimmed ? { style: { opacity: 0.5 } } : {}),
        },
      }}
      badgeContent={badgeContent}
      max={max}
    >
      {children}
    </BaseBadge>
  );
}

export default Badge;
